export default {
    state: {
        invoiceData: [],
        invoiceIsLoading: false,
        paymentButtonsVisible: false
    },
    mutations: {
        setInvoiceData (state, data) {
            state.invoiceData = data
        },
        startInvoiceLoading (state) {
            state.invoiceIsLoading = true
        },
        stopInvoiceLoading (state) {
            state.invoiceIsLoading = false
        },
        setPaymentButtonsVisible (state, data) {
            state.paymentButtonsVisible = data
        }
    },
    actions: {
        setInvoiceData ({ commit }, data) {
            commit('setInvoiceData', data)
        },
        startInvoiceLoading ({ commit }) {
            commit('startInvoiceLoading')
        },
        stopInvoiceLoading ({ commit }) {
            commit('stopInvoiceLoading')
        },
        setPaymentButtonsVisible ({ commit }, data) {
            commit('setPaymentButtonsVisible', data)
        }
    },
    getters: {
        invoiceData: (state) => state.invoiceData,
        invoiceIsLoading: (state) => state.invoiceIsLoading,
        paymentButtonsVisible: (state) => state.paymentButtonsVisible
    }
}
